import { render, staticRenderFns } from "./EditAutoDeliveryCancelReasons.vue?vue&type=template&id=5d221090&scoped=true&lang=pug&"
import script from "./EditAutoDeliveryCancelReasons.vue?vue&type=script&lang=js&"
export * from "./EditAutoDeliveryCancelReasons.vue?vue&type=script&lang=js&"
import style0 from "./EditAutoDeliveryCancelReasons.vue?vue&type=style&index=0&id=5d221090&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d221090",
  null
  
)

export default component.exports